import { createSelector } from 'reselect';

const getHasToken = state => state.auth.hasToken;

export const getIsConnectionFailedMessageVisible = state =>
  state.auth.isConnectionFailedMessageVisible;

const getPage = state => (!state.auth.hasToken ? 'login' : 'profile');

const getSignUp = createSelector(
  getHasToken,
  getIsConnectionFailedMessageVisible,
  getPage,
  (
    hasToken,
    isConnectionFailedMessageVisible,
    page,
  ) => ({
    hasToken,
    isConnectionFailedMessageVisible,
    page,
  })
);

export { getSignUp };